"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _lodash = require("lodash");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CardStore = /*#__PURE__*/function (_RootStore) {
  function CardStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, CardStore);
    _this = _callSuper(this, CardStore);
    _this.config = {
      model: _models.Card,
      deserialize: true,
      GET: {
        index: '/cards',
        show: '/cards/:cardId'
      },
      POST: {
        create: '/cards',
        batchUpdate: '/cards/batch_update',
        batchReset: '/cards/batch_reset',
        batchDestroy: '/cards/batch_destroy'
      },
      MULTIPART_POST: {
        create: '/cards'
      },
      PUT: {
        destroyReviews: '/cards/:cardId/destroy_reviews',
        retire: '/cards/:cardId/retire',
        snooze: '/cards/:cardId/snooze',
        update: '/cards/:cardId'
      },
      DELETE: {
        destroy: '/cards/:cardId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(CardStore, _RootStore);
  return (0, _createClass2["default"])(CardStore, [{
    key: "batchUpdate",
    value: function batchUpdate(params, callback) {
      this.api(params, callback, 'POST', 'batchUpdate');
    }
  }, {
    key: "batchReset",
    value: function batchReset(params, callback) {
      this.api(params, callback, 'POST', 'batchReset');
    }
  }, {
    key: "batchDestroy",
    value: function batchDestroy(params, callback) {
      this.api(params, callback, 'POST', 'batchDestroy');
    }
  }, {
    key: "resetSpacedRepetition",
    value: function resetSpacedRepetition(params, callback) {
      this.api(params, callback, 'PUT', 'resetSpacedRepetition');
    }
  }, {
    key: "destroyReviews",
    value: function destroyReviews(params, callback) {
      this.api(params, callback, 'PUT', 'destroyReviews');
    }
  }, {
    key: "retire",
    value: function retire(params, callback) {
      this.api(params, callback || _lodash.noop, 'PUT', 'retire');
    }
  }, {
    key: "snooze",
    value: function snooze(params, callback) {
      this.api(params, callback || _lodash.noop, 'PUT', 'snooze');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new CardStore();